module.exports = __webpack_public_path__ + "static/media/3c.86de352e.jpg";